let moduleVersion = "3.21.2";
export const getCurrentVersion = () => moduleVersion;
export const setCurrentVersion = version => {
  moduleVersion = version;
};
//# sourceMappingURL=version.js.map